module.exports = __webpack_public_path__ + "img/b_log_moving.e817e727.png";